module.exports = __webpack_public_path__ + "static/media/q_of_clubs2.1037f872.png";